/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import {View} from 'react-native';
import {Feather} from '@expo/vector-icons';

interface I_Deliveries_Package_Icon {
  tintColor: string;
  variant?: 'truck-package' | 'package-truck';
}

export default function DeliveriesPackageIcon(
  props: I_Deliveries_Package_Icon,
) {
  const packageFirst = props.variant === 'package-truck';

  return (
    <View
      style={{
        width: 34,
        height: 22,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Feather
        name={packageFirst ? 'package' : 'truck'}
        color={props?.tintColor}
        size={20}
        style={{
          position: 'absolute',
          left: packageFirst ? 0 : 2,
          top: packageFirst ? 1 : 2,
          opacity: packageFirst ? 0.95 : 1,
        }}
      />
      <Feather
        name={packageFirst ? 'truck' : 'package'}
        color={props?.tintColor}
        size={14}
        style={{
          position: 'absolute',
          right: packageFirst ? 1 : 0,
          bottom: packageFirst ? 1 : 0,
          opacity: packageFirst ? 1 : 0.95,
        }}
      />
    </View>
  );
}
